import { render } from "preact";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import "@fontsource/jetbrains-mono/700.css";
import "./styles/global.css";

const root = document.getElementById("app");
const valantisFaviconHref = "/favicon.svg";

function applyShellBranding() {
  document.title = "Valantis Prime";

  let iconLink = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
  if (!iconLink) {
    iconLink = document.createElement("link");
    iconLink.rel = "icon";
    document.head.appendChild(iconLink);
  }
  iconLink.type = "image/svg+xml";
  iconLink.href = valantisFaviconHref;
}

function renderBootstrapError(message: string) {
  if (!root) {
    return;
  }

  const escapedMessage = message
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");

  root.innerHTML = `
    <div style="padding:24px;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;color:#f8fafc;background:#111827;min-height:100vh;">
      <h1 style="margin:0 0 12px;font-size:18px;">Valantis Prime bootstrap error</h1>
      <pre style="white-space:pre-wrap;line-height:1.5;">${escapedMessage}</pre>
    </div>
  `;
}

async function bootstrap() {
  try {
    applyShellBranding();
    const { App } = await import("./app/App");
    render(<App />, root!);
  } catch (error) {
    renderBootstrapError(error instanceof Error ? error.stack ?? error.message : String(error));
  }
}

void bootstrap();
